var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-loader",style:({color: _vm.color})},[_c('div',{staticClass:"box"},[_c('v-svg',{staticClass:"fox"},[_vm._v("fox")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }